<template>
  <Img :src="qrCode" class="qrcode" v-if="qrCode" />
  <Loading v-else class="qrcode" :overlay="false" />
</template>

<script lang="ts" setup>
import { PositionCode } from '@rendora/common/entities/analysis_backend';
import { QRCodeSizeType } from '@rendora/common/features/contact/types';
import { Img } from '@rendora/design/components/img/index';
import { Loading } from '@rendora/design/components/loading/index';
import { useQrCode } from '../libs/useQrcode';

const props = defineProps<{
  code: PositionCode;
  source_from: string;
  size?: QRCodeSizeType;
}>();

const { qrCode } = useQrCode(props.code);
</script>
<style lang="scss" scoped>
.qrcode-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qrcode {
  background-color: var(--back-2);
  transition: all 0.3s ease;
  display: block;
  margin: 0 auto;
}
</style>
